import { inject, Service } from "@angular/core"
import { Observable } from "rxjs"
import { HttpClient } from "@angular/common/http"
import { PromotionalContent, PagedPromotionalContent, CreatePromotionalContent, ModifyObject } from "../models"
import { environment } from "src/environments/environment"

export interface ColumnFilter {
    field: string
    value: string
    matchMode: string
}

export interface GetPromContentPagedParams {
    search?: string
    sortField?: string
    sortDescending?: boolean
    page: number
    pageSize: number
    columnFilters?: ColumnFilter[]
}

@Service({ autoProvided: false })
export class PromotionalContentService {
    private _http = inject(HttpClient)
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.promotionalContent

    Get(): Observable<PromotionalContent[]> {
        return this._http.get<PromotionalContent[]>(this._apiUrl)
    }

    GetByMasterId(masterId: string): Observable<PromotionalContent> {
        return this._http.get<PromotionalContent>(this.ByMasterIdUrl(masterId))
    }
    ByMasterIdUrl(masterId: string): string {
        return `${this._apiUrl}/${masterId}`
    }

    GetPaged(params: GetPromContentPagedParams): Observable<PagedPromotionalContent> {
        const request = this.PagedRequest(params)
        return this._http.get<PagedPromotionalContent>(request.url, { params: request.params })
    }
    PagedRequest(params: GetPromContentPagedParams): { url: string; params: Record<string, string> } {
        const httpParams: Record<string, string> = {
            page: params.page.toString(),
            pageSize: params.pageSize.toString(),
        }
        if (params.search) httpParams["search"] = params.search
        if (params.sortField) httpParams["sortField"] = params.sortField
        if (params.sortDescending !== undefined) httpParams["sortDescending"] = params.sortDescending.toString()
        if (params.columnFilters?.length) httpParams["columnFilters"] = JSON.stringify(params.columnFilters)

        return { url: this._apiUrl + "/paged", params: httpParams }
    }

    Create(createPromContent: CreatePromotionalContent): Observable<PromotionalContent> {
        return this._http.post<PromotionalContent>(this._apiUrl, createPromContent)
    }

    Modify(masterId: string, data: ModifyObject): Observable<PromotionalContent> {
        return this._http.patch<PromotionalContent>(this.ByMasterIdUrl(masterId), data)
    }

    Delete(masterId: string): Observable<string> {
        return this._http.delete<string>(this.ByMasterIdUrl(masterId))
    }
}
